export default __webpack_public_path__ + "language-dropdown/RU.png";